import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { useAuthStore } from "@stores/auth";

function Logout() {
  const { authToken, logout } = useAuthStore();
  
  useEffect(() => {
    logout();
  }, [logout]);

  const hasAuthToken = Boolean(authToken);
  return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth/login" />;
}

export default Logout;
